import { Link } from '@repo/web-ui/components/link'
import { IconArrowForward } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'
import { LinksContainer } from './links-container'
import type { LinkChip } from './links-data'
import { PAGE_LINKS } from './links-data'
import { useTranslations } from 'next-intl'

export function Links({
  slug,
  location = 'top',
  className,
}: {
  slug: string
  location?: 'top' | 'bottom' | 'explore-more'
  className?: string
}) {
  let links: LinkChip[] = []
  if (location === 'top') {
    links = PAGE_LINKS[slug].top
  } else if (location === 'bottom') {
    links = PAGE_LINKS[slug].bottom
  } else if (location === 'explore-more') {
    links = PAGE_LINKS[slug].exploreMore
  }

  return (
    <LinksContainer className={className} testid={`link-blocks-${location}`}>
      {links.map(link => (
        <Chip
          key={link.href}
          label={link.label}
          href={link.href}
          isLinkStyle={location === 'explore-more'}
        />
      ))}
    </LinksContainer>
  )
}

function Chip({
  label,
  href,
  isLinkStyle = false,
}: {
  label: string
  href: string
  isLinkStyle?: boolean
}) {
  const t = useTranslations('pages.fonts.links')
  return (
    <Link
      href={href}
      className={tw(
        'flex gap-2 justify-center items-center rounded-[8px] px-4 py-2 text-cf-grey-1000 whitespace-nowrap',
        isLinkStyle
          ? 'border-2 border-cf-purple-1000 font-semibold pr-3 hover:underline'
          : 'bg-cf-grey-200 hover:bg-cf-purple-200 active:bg-cf-purple-50',
      )}
    >
      <span>{t(label)}</span>
      {isLinkStyle ? <IconArrowForward className="size-5 text-cf-grey-1000" /> : null}
    </Link>
  )
}
